import * as React from 'react';
import { colors } from '../../../index';

const IconProfileCard = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 15 11",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.281 10.897H1.72c-.95 0-1.72-.746-1.72-1.665V1.665C0 .746.77 0 1.719 0H13.28C14.23 0 15 .746 15 1.665v7.567c0 .919-.77 1.665-1.719 1.665zM1.72.908a.77.77 0 00-.782.757v7.567c0 .417.351.757.782.757h11.56a.77.77 0 00.781-.757V1.665a.77.77 0 00-.78-.757H1.718z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.688 5.449c-.862 0-1.563-.68-1.563-1.514s.701-1.513 1.563-1.513c.86 0 1.562.679 1.562 1.513 0 .834-.701 1.514-1.563 1.514zm0-2.12a.616.616 0 00-.625.606c0 .334.28.605.625.605a.616.616 0 00.624-.605.616.616 0 00-.625-.605zm2.343 5.147a.462.462 0 01-.468-.455V7.72a.77.77 0 00-.782-.757H3.594a.77.77 0 00-.781.757v.302c0 .251-.21.455-.47.455a.462.462 0 01-.468-.455V7.72c0-.919.77-1.665 1.719-1.665H5.78c.948 0 1.719.746 1.719 1.665v.302c0 .251-.21.455-.469.455zm5.625-4.844H9.22a.462.462 0 01-.469-.454c0-.25.21-.454.469-.454h3.437c.259 0 .469.204.469.454s-.21.454-.469.454zm0 2.422H9.22a.462.462 0 01-.47-.454c0-.25.21-.454.469-.454h3.437c.259 0 .469.203.469.454 0 .25-.21.454-.469.454zm0 2.422H9.22a.462.462 0 01-.469-.455c0-.25.21-.454.469-.454h3.437c.259 0 .469.204.469.454 0 .251-.21.455-.469.455z"
  })));
};

export default IconProfileCard;